import {combineReducers} from "redux";

import {ILatestQueryAction, reduceLatestQuery, reduceRequestState, reduceResponse, RequestState} from "@pg-mono/request-state";

import {IRegionPathRegion} from "../../../region/fetch_region_path";
import {fetchOfferListSearchActionTypes} from "../../helpers/searches/fetch_search";
import {ISearchAPIResponse} from "../../types/ISearchAPIResponse";
import {fetchOfferListArticlesTypes, IOfferArticle} from "../actions/fetch_offer_list_articles";
import {fetchOfferListNearbyRegionsTypes, fetchOfferListVoivodeshipTopCitiesTypes, IOfferListNearbyRegion} from "../actions/fetch_offer_list_nearby_regions";
import {fetchOfferListRegionPathTypes} from "../actions/fetch_offer_list_parent_regions";
import {fetchOfferListRecommendedRegionsTypes, IRecommendedRegion, IVoivodeshipRegion} from "../actions/fetch_offer_list_recommended_regions";
import {fetchSelectedRegionEstimatedPriceTypes, ISelectedRegionEstimatedPrice} from "../actions/fetch_selected_region_estimated_price";
import {fetchSelectedRegionDataTypes, ISelectedRegion} from "../actions/offer_list_selected_data_actions";
import {IOfferListListStore, offerListListReducer} from "./desktop_offer_list_list_reducer";
import {offerListSelectedRegionsReducer} from "./offer_list_selected_regions_reducer";

export interface IOfferListStore {
    list: IOfferListListStore;
    selectedRegions: ISelectedRegion[];
    selectedRegionsLatestQuery: string | string[] | Record<string, string>[];
    selectedRegionEstimatedPrices: ISelectedRegionEstimatedPrice[];
    // related articles
    articles: IOfferArticle[];
    articlesRequest: RequestState;
    articlesLatestQuery: Record<string, string>;
    // nearby regions for linkoza
    nearbyRegions: IOfferListNearbyRegion[];
    nearbyRegionsLatestQuery: Record<string, string>;
    // parent regions for linkoza
    regionPath: IRegionPathRegion[];
    regionPathRequestState: RequestState;
    regionPathLatestQuery: Record<string, string>;
    search: ISearchAPIResponse | null;
    // nearby regions for linkoza
    recommendedRegions: IRecommendedRegion[];
    recommendedRegionsRequestState: RequestState;
    recommendedRegionsLatestQuery: Record<string, string>;
    voivodeshipTopCities: IVoivodeshipRegion[];
    voivodeshipTopCitiesLatestQuery: Record<string, string>;
}

export const offerListReducer = combineReducers({
    list: offerListListReducer,
    selectedRegions: offerListSelectedRegionsReducer(),
    selectedRegionsLatestQuery: reduceLatestQuery(fetchSelectedRegionDataTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => string | string[] | Record<string, string>[],
    selectedRegionEstimatedPrices: reduceResponse<ISelectedRegionEstimatedPrice[]>(fetchSelectedRegionEstimatedPriceTypes, []),
    //related articles
    articles: reduceResponse<IOfferArticle[]>(fetchOfferListArticlesTypes, []),
    articlesRequest: reduceRequestState(fetchOfferListArticlesTypes),
    articlesLatestQuery: reduceLatestQuery(fetchOfferListArticlesTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>,
    // nearby regions
    nearbyRegions: reduceResponse<IOfferListNearbyRegion[]>(fetchOfferListNearbyRegionsTypes, []),
    nearbyRegionsRequest: reduceRequestState(fetchOfferListNearbyRegionsTypes),
    nearbyRegionsLatestQuery: reduceLatestQuery(fetchOfferListNearbyRegionsTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>,
    // region path
    regionPath: reduceResponse<IRegionPathRegion[]>(fetchOfferListRegionPathTypes, []),
    regionPathRequestState: reduceRequestState(fetchOfferListRegionPathTypes),
    regionPathLatestQuery: reduceLatestQuery(fetchOfferListRegionPathTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>,
    search: reduceResponse<ISearchAPIResponse>(fetchOfferListSearchActionTypes),
    // nearby regions for sidebar
    recommendedRegions: reduceResponse<IRecommendedRegion[]>(fetchOfferListRecommendedRegionsTypes, []),
    recommendedRegionsRequestState: reduceRequestState(fetchOfferListRecommendedRegionsTypes),
    recommendedRegionsLatestQuery: reduceLatestQuery(fetchOfferListRecommendedRegionsTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>,
    voivodeshipTopCities: reduceResponse<IVoivodeshipRegion[]>(fetchOfferListVoivodeshipTopCitiesTypes, []),
    voivodeshipTopCitiesLatestQuery: reduceLatestQuery(fetchOfferListVoivodeshipTopCitiesTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>
});
import {combineReducers} from "redux";

import {ILatestQueryAction, reduceLatestQuery, reduceRequestState, reduceResponse, RequestState} from "@pg-mono/request-state";

import {IRegionPathRegion} from "../../../region/fetch_region_path";
import {fetchOfferListSearchActionTypes} from "../../helpers/searches/fetch_search";
import {ISearchAPIResponse} from "../../types/ISearchAPIResponse";
import {fetchOfferListArticlesTypes, IOfferArticle} from "../actions/fetch_offer_list_articles";
import {fetchOfferListNearbyRegionsTypes, fetchOfferListVoivodeshipTopCitiesTypes, IOfferListNearbyRegion} from "../actions/fetch_offer_list_nearby_regions";
import {fetchOfferListRegionPathTypes} from "../actions/fetch_offer_list_parent_regions";
import {fetchOfferListRecommendedRegionsTypes, IRecommendedRegion, IVoivodeshipRegion} from "../actions/fetch_offer_list_recommended_regions";
import {fetchSelectedRegionEstimatedPriceTypes, ISelectedRegionEstimatedPrice} from "../actions/fetch_selected_region_estimated_price";
import {fetchSelectedRegionDataTypes, ISelectedRegion} from "../actions/offer_list_selected_data_actions";
import {IOfferListListStore, offerListListReducer} from "./desktop_offer_list_list_reducer";
import {offerListSelectedRegionsReducer} from "./offer_list_selected_regions_reducer";

export interface IOfferListStore {
    list: IOfferListListStore;
    selectedRegions: ISelectedRegion[];
    selectedRegionsLatestQuery: string | string[] | Record<string, string>[];
    selectedRegionEstimatedPrices: ISelectedRegionEstimatedPrice[];
    // related articles
    articles: IOfferArticle[];
    articlesRequest: RequestState;
    articlesLatestQuery: Record<string, string>;
    // nearby regions for linkoza
    nearbyRegions: IOfferListNearbyRegion[];
    nearbyRegionsLatestQuery: Record<string, string>;
    // parent regions for linkoza
    regionPath: IRegionPathRegion[];
    regionPathRequestState: RequestState;
    regionPathLatestQuery: Record<string, string>;
    search: ISearchAPIResponse | null;
    // nearby regions for linkoza
    recommendedRegions: IRecommendedRegion[];
    recommendedRegionsRequestState: RequestState;
    recommendedRegionsLatestQuery: Record<string, string>;
    voivodeshipTopCities: IVoivodeshipRegion[];
    voivodeshipTopCitiesLatestQuery: Record<string, string>;
}

export const offerListReducer = combineReducers({
    list: offerListListReducer,
    selectedRegions: offerListSelectedRegionsReducer(),
    selectedRegionsLatestQuery: reduceLatestQuery(fetchSelectedRegionDataTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => string | string[] | Record<string, string>[],
    selectedRegionEstimatedPrices: reduceResponse<ISelectedRegionEstimatedPrice[]>(fetchSelectedRegionEstimatedPriceTypes, []),
    //related articles
    articles: reduceResponse<IOfferArticle[]>(fetchOfferListArticlesTypes, []),
    articlesRequest: reduceRequestState(fetchOfferListArticlesTypes),
    articlesLatestQuery: reduceLatestQuery(fetchOfferListArticlesTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>,
    // nearby regions
    nearbyRegions: reduceResponse<IOfferListNearbyRegion[]>(fetchOfferListNearbyRegionsTypes, []),
    nearbyRegionsRequest: reduceRequestState(fetchOfferListNearbyRegionsTypes),
    nearbyRegionsLatestQuery: reduceLatestQuery(fetchOfferListNearbyRegionsTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>,
    // region path
    regionPath: reduceResponse<IRegionPathRegion[]>(fetchOfferListRegionPathTypes, []),
    regionPathRequestState: reduceRequestState(fetchOfferListRegionPathTypes),
    regionPathLatestQuery: reduceLatestQuery(fetchOfferListRegionPathTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>,
    search: reduceResponse<ISearchAPIResponse>(fetchOfferListSearchActionTypes),
    // nearby regions for sidebar
    recommendedRegions: reduceResponse<IRecommendedRegion[]>(fetchOfferListRecommendedRegionsTypes, []),
    recommendedRegionsRequestState: reduceRequestState(fetchOfferListRecommendedRegionsTypes),
    recommendedRegionsLatestQuery: reduceLatestQuery(fetchOfferListRecommendedRegionsTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>,
    voivodeshipTopCities: reduceResponse<IVoivodeshipRegion[]>(fetchOfferListVoivodeshipTopCitiesTypes, []),
    voivodeshipTopCitiesLatestQuery: reduceLatestQuery(fetchOfferListVoivodeshipTopCitiesTypes) as unknown as (
        state: Record<string, string | string[]> | undefined,
        action: ILatestQueryAction
    ) => Record<string, string>
});
